import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import countries from './countries.json';

export interface ICountry {
  nombre: string;
  iso2: string;
  phone_code: string;
}

@Component({
  selector: 'app-countries-autocomplete',
  templateUrl: './countries-autocomplete.component.html',
  styleUrls: ['./countries-autocomplete.component.scss'],
})
export class CountriesAutocompleteComponent implements OnInit {
  currentCountry: ICountry = null;
  countries: ICountry[] = countries;
  filteredCountries: Observable<ICountry[]>;

  @Input() control: AbstractControl | any;
  @Input() height: string = '';
  @Output() sendCountries = new EventEmitter();

  ngOnInit() {
    if (typeof this.control.value === 'string') {
      const value = this.countries.find(
        (x) => x.phone_code === this.control.value
      );
      this.control.setValue(value);
      this.currentCountry = value;
    }
    if (this.control.value === null) {
      const defaultValue: ICountry = this.countries.find(
        (x) => x.iso2 === 'ES'
      );
      this.control.setValue(defaultValue);
      this.currentCountry = defaultValue;
    }
    // this.control.disable();
    this.sendCountries.emit(this.control);
    this.filteredCountries = this.control.valueChanges.pipe(
      startWith(''),
      map((value: any) => {
        const name = typeof value === 'string' ? value : value?.nombre;
        return name ? this._filter(name as string) : this.countries.slice();
      })
    );
  }

  displayFn(country: ICountry): string {
    return country && country.nombre ? '+ ' + country.phone_code : '';
  }

  controlAutocomplete() {
    this.control.enable();
    this.control.reset();
  }

  selectCountry() {
    this.currentCountry = this.control.value;
    this.sendCountries.emit(this.control);
    // this.control.disable();
  }

  private _filter(value: string): ICountry[] {
    const filterValue = value.toLowerCase();
    return this.countries.filter((country) =>
      country.nombre.toLowerCase().includes(filterValue)
    );
  }
}
